import React, { ReactNode } from 'react'
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  SelectChangeEvent,
  SxProps,
  Theme,
} from '@mui/material'

interface SelectOption {
  value: string | number
  text: string | ReactNode
}

interface OutlinedSelectProps {
  value: string | number | undefined
  label: string | ReactNode
  name?: string
  id?: string
  className?: string
  options: SelectOption[]
  onChange: (event: SelectChangeEvent<string | number>) => void
  style?: React.CSSProperties
  sx?: SxProps<Theme>
}

const OutlinedSelect = ({
  value,
  label,
  name,
  id,
  className,
  options,
  onChange,
  style,
  sx,
}: OutlinedSelectProps) => {
  return (
    <FormControl variant="outlined" className={className} style={style} sx={sx}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        name={name}
        id={id}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default OutlinedSelect
